import { checkDeploymentIntegrationsPermission } from '@repo/guards/route-checks';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/org/$organization/settings/deployment-integrations/$integrationType/add')({
    beforeLoad: async (param)=>{
        let { params, context: { queryClient } } = param;
        const can = await checkDeploymentIntegrationsPermission(queryClient, params.organization);
        if (!can) {
            throw redirect({
                to: '/403',
                search: {
                    from: '/org/$organization/settings/deployment-integrations/add'
                }
            });
        }
    }
});
